import React from "react";

const sscecRoutes = [
    {
    	path: "/applications/sscec/list",
        component: React.lazy(() =>
            import("./SSCECList")
        ),
    },
    {
    	path: "/applications/sscc/list",
        component: React.lazy(() =>
            import("./SSCECList")
        ),
    },
    {
    	path: "/applications/sscec/:appName/:viewType/:appnId",
        component: React.lazy(() =>
            import("./SSCECFormDetails")
        ),
    },
    {
    	path: "/applications/sscc/:appName/:viewType/:appnId",
        component: React.lazy(() =>
            import("./SSCECFormDetails")
        ),
    },
];

export default sscecRoutes;